import React, { useEffect, useState } from "react";
import get from "lodash/get";

import Separator from "../../atoms/separator";
import StoryCard23 from "../../molecules/story-card23";
import StoryCard15 from "../../molecules/story-card15";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import CollectionName from "../../molecules/collection-name";
import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";

import "./top-news-3.m.css";

function TopNews3({ collection, index }) {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <>
      <div className="hide-mobile">
        <CollectionTitleHeader collection={collection} index={index} />
        <div styleName="wrapper">
          <div styleName="big-story">
            <StoryCard23 story={stories[0]} />
          </div>
          {stories?.slice(1, 7).map((item, index) => (
            <div key={index} styleName="small-story">
              <StoryCard15 story={item} key={index} />
            </div>
          ))}
        </div>
        <Separator />
      </div>
      {isMobile ? (
        <div className="hide-desktop">
          <CollectionName collection={collection} />
          <div styleName="wrapper">
            <div styleName="big-story">
              <StoryCard23 story={stories[0]} />
            </div>
            <div styleName="small-card section">
              <StoryCard15 story={stories[1]} showDate={true} />
            </div>
            <div styleName="section">
              {stories.slice(2, 6).map((item, idx) => (
                <>
                  <div styleName="small-card" key={idx}>
                    <StoryCard15 story={item} showDate={true} />
                  </div>
                  {idx === 0 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
                </>
              ))}
            </div>
            <div styleName="section">
              <StoryCard15 story={stories[6]} showDate={true} />
            </div>
            <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} />

            <div styleName="section">
              {stories.slice(7, 11).map((item, idx) => (
                <>
                  <div styleName="small-card" key={idx}>
                    <StoryCard15 story={item} showDate={true} />
                  </div>
                  {idx === 3 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
                </>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default TopNews3;
